import '@angular/compiler';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAccountingClosingComponent } from './page.accounting.closing/page.accounting.closing.component';
import { PageMembersComponent } from './page.members/page.members.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAccountingReviewComponent } from './page.accounting.review/page.accounting.review.component';
import { PageAccountingUploadComponent } from './page.accounting.upload/page.accounting.upload.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageDashboardComponent } from './page.dashboard/page.dashboard.component';
import { PageSettingsComponent } from './page.settings/page.settings.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PagePostsComponent } from './page.posts/page.posts.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageAccountingRulesComponent } from './page.accounting.rules/page.accounting.rules.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageAccountingMembersComponent } from './page.accounting.members/page.accounting.members.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageMypageComponent } from './page.mypage/page.mypage.component';
import { PagePostsItemComponent } from './page.posts.item/page.posts.item.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    },
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "accounting/closing/:month?",
                component: PageAccountingClosingComponent,
                "app_id": "page.accounting.closing"
            },
            {
                "path": "members",
                component: PageMembersComponent,
                "app_id": "page.members"
            },
            {
                "path": "accounting/review/:uploadId?",
                component: PageAccountingReviewComponent,
                "app_id": "page.accounting.review"
            },
            {
                "path": "accounting/upload",
                component: PageAccountingUploadComponent,
                "app_id": "page.accounting.upload"
            },
            {
                "path": "dashboard",
                component: PageDashboardComponent,
                "app_id": "page.dashboard"
            },
            {
                "path": "settings",
                component: PageSettingsComponent,
                "app_id": "page.settings"
            },
            {
                "path": "posts",
                component: PagePostsComponent,
                "app_id": "page.posts"
            },
            {
                "path": "accounting/rules",
                component: PageAccountingRulesComponent,
                "app_id": "page.accounting.rules"
            },
            {
                "path": "accounting/members",
                component: PageAccountingMembersComponent,
                "app_id": "page.accounting.members"
            },
            {
                "path": "mypage",
                component: PageMypageComponent,
                "app_id": "page.mypage"
            },
            {
                "path": "posts/:id/:tab?",
                component: PagePostsItemComponent,
                "app_id": "page.posts.item"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }